import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetopanvelcabs() {



  const cardData = {


  keyword: "Pune to Panvel Cabs",

  headingDescription: "Trustline Cab provides reliable Pune to Panvel cab services with safe, comfortable, and affordable transportation for business travel, airport transfers, family trips, corporate meetings, and outstation journeys. Whether you need a one-way taxi or a round-trip cab, our experienced chauffeurs ensure timely pickups and a smooth, hassle-free journey. Our fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury vehicles to suit every travel requirement. With transparent pricing, doorstep pickup, easy online booking, flexible travel schedules, and 24/7 customer support, Trustline Travels is your trusted choice for Pune to Panvel taxi services.",

  topPlaces: [
    {
      title: "New Panvel",
      description: "New Panvel is a rapidly developing residential and commercial locality known for its modern infrastructure, educational institutions, shopping centers, and excellent connectivity."
    },
    {
      title: "Kamothe",
      description: "Kamothe is a prominent residential and business area featuring commercial establishments, hospitals, educational institutes, and easy access to major highways."
    },
    {
      title: "Kalamboli",
      description: "Kalamboli is an important logistics and commercial hub with wholesale markets, transport companies, warehouses, and industrial establishments."
    },
    {
      title: "Kharghar",
      description: "Kharghar is a well-planned node of Navi Mumbai known for corporate offices, educational institutions, business centers, and premium residential developments."
    },
    {
      title: "Panvel MIDC",
      description: "Panvel MIDC is a significant industrial zone housing manufacturing companies, engineering firms, logistics operators, and commercial businesses."
    },
    {
      title: "CIDCO Exhibition Centre",
      description: "CIDCO Exhibition Centre is a major venue for trade fairs, exhibitions, business conferences, and corporate events in Navi Mumbai."
    },
    {
      title: "Karnala Bird Sanctuary",
      description: "Karnala Bird Sanctuary is a popular eco-tourism destination offering birdwatching, trekking trails, lush forests, and the historic Karnala Fort."
    },
    {
      title: "Karnala Fort",
      description: "Karnala Fort is a historic hill fort attracting trekkers and history enthusiasts with panoramic views of the surrounding Western Ghats."
    },
    {
      title: "Adlabs Imagica",
      description: "Adlabs Imagica is a renowned amusement park near Panvel offering thrilling rides, entertainment shows, and family-friendly attractions."
    },
    {
      title: "Pandavkada Falls",
      description: "Pandavkada Falls is a scenic waterfall near Kharghar, known for its natural beauty and refreshing surroundings during the monsoon season."
    }
  ],






"services": [
  {
    "name": "Pune to Panvel Cab Fare",
    "description": "Check Pune to Panvel Cab Fare with transparent pricing, professional drivers, AC vehicles, and no hidden charges."
  },
  {
    "name": "Pune to Panvel Cab One Way",
    "description": "Book Pune to Panvel Cab One Way for affordable single-trip travel with doorstep pickup and comfortable vehicles."
  },
  {
    "name": "Pune to Panvel Cab Price",
    "description": "Find the latest Pune to Panvel Cab Price for Sedan, Ertiga, Innova Crysta, Kia Carens, and premium vehicles."
  },
  {
    "name": "Pune to Panvel Distance Taxi",
    "description": "Hire a Pune to Panvel Distance Taxi for comfortable intercity travel with experienced chauffeurs and fixed fares."
  },
  {
    "name": "Pune to Panvel Taxi Fare",
    "description": "Check Pune to Panvel Taxi Fare for one-way, round-trip, business travel, and family journeys."
  },
  {
    "name": "Pune to Panvel Taxi",
    "description": "Book Pune to Panvel Taxi with clean AC vehicles, professional drivers, and reliable outstation service."
  },
  {
    "name": "Pune to Panvel Cabs",
    "description": "Choose Pune to Panvel Cabs for safe, affordable, and comfortable intercity travel with multiple vehicle options."
  },
  {
    "name": "Pune to Panvel Cab",
    "description": "Book Pune to Panvel Cab for one-way, round-trip, airport transfers, and business travel with fixed pricing."
  },
  {
    "name": "Pune to Panvel Cab Service",
    "description": "Reliable Pune to Panvel Cab Service with punctual pickup, sanitized vehicles, and experienced chauffeurs."
  },
  {
    "name": "Pune to Panvel Taxi",
    "description": "Hire Pune to Panvel Taxi for comfortable travel with transparent fares and professional drivers."
  },
  {
    "name": "Pune to Panvel Taxi Service",
    "description": "Choose Pune to Panvel Taxi Service for business trips, family travel, and outstation taxi bookings."
  },
  {
    "name": "Pune to Panvel Cab Booking",
    "description": "Book Pune to Panvel Cab Booking online with instant confirmation and 24x7 customer support."
  },
  {
    "name": "Online Pune to Panvel Cab Booking",
    "description": "Reserve Online Pune to Panvel Cab Booking with quick confirmation and multiple vehicle choices."
  },
  {
    "name": "Book Pune to Panvel Cab",
    "description": "Book Pune to Panvel Cab easily for safe, reliable, and affordable travel anytime."
  },
  {
    "name": "Pune to Panvel One Way Cab",
    "description": "Choose Pune to Panvel One Way Cab without return charges for economical travel."
  },
  {
    "name": "Pune to Panvel Round Trip Cab",
    "description": "Book Pune to Panvel Round Trip Cab for same-day return and flexible travel plans."
  },
  {
    "name": "Pune to Panvel Outstation Cab",
    "description": "Hire Pune to Panvel Outstation Cab with experienced drivers and clean AC vehicles."
  },
  {
    "name": "Pune to Panvel Car Rental",
    "description": "Choose Pune to Panvel Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, and SUV vehicles."
  },
  {
    "name": "Pune to Panvel Private Cab",
    "description": "Book Pune to Panvel Private Cab for exclusive travel with flexible pickup timings."
  },
  {
    "name": "Pune to Panvel AC Cab",
    "description": "Travel comfortably with Pune to Panvel AC Cab featuring clean interiors and experienced chauffeurs."
  },
  {
    "name": "Pune to Panvel Intercity Cab",
    "description": "Choose Pune to Panvel Intercity Cab for smooth highway travel with fixed pricing."
  },
  {
    "name": "Pune to Panvel Travel Cab",
    "description": "Book Pune to Panvel Travel Cab for leisure trips, business visits, and family journeys."
  },
  {
    "name": "Pune to Panvel Drop Taxi",
    "description": "Reserve Pune to Panvel Drop Taxi for convenient one-way travel with doorstep pickup."
  },
  {
    "name": "Pune to Panvel Cab Hire",
    "description": "Hire Pune to Panvel Cab with professional drivers and affordable fares."
  },
  {
    "name": "Pune to Panvel Taxi Booking",
    "description": "Complete Pune to Panvel Taxi Booking online with instant confirmation and transparent pricing."
  },
  {
    "name": "Innova Crysta Pune to Panvel Cab",
    "description": "Book Innova Crysta Pune to Panvel Cab for luxury family travel and airport transfers."
  },
  {
    "name": "Ertiga Pune to Panvel Cab",
    "description": "Hire Ertiga Pune to Panvel Cab for comfortable 6 to 7 seater travel."
  },
  {
    "name": "Sedan Pune to Panvel Cab",
    "description": "Book Sedan Pune to Panvel Cab for affordable business and personal travel."
  },
  {
    "name": "Kia Carens Pune to Panvel Cab",
    "description": "Choose Kia Carens Pune to Panvel Cab for spacious and comfortable family journeys."
  },
  {
    "name": "Swift Dzire Pune to Panvel Cab",
    "description": "Book Swift Dzire Pune to Panvel Cab for economical and reliable intercity travel."
  },
  {
    "name": "Hyundai Aura Pune to Panvel Cab",
    "description": "Hire Hyundai Aura Pune to Panvel Cab for budget-friendly outstation trips."
  },
  {
    "name": "Premium Cab Pune to Panvel",
    "description": "Choose Premium Cab Pune to Panvel for executive travel with premium comfort."
  },
  {
    "name": "Luxury Cab Pune to Panvel",
    "description": "Book Luxury Cab Pune to Panvel with premium vehicles and professional chauffeurs."
  },
  {
    "name": "Family Cab Pune to Panvel",
    "description": "Hire Family Cab Pune to Panvel with spacious seating and luggage capacity."
  },
  {
    "name": "Pune to Panvel Station Cab",
    "description": "Book Pune to Panvel Station Cab for convenient railway station transfers."
  },
  {
    "name": "Pune to New Panvel Cab",
    "description": "Choose Pune to New Panvel Cab for safe and reliable intercity travel."
  },
  {
    "name": "Pune to Old Panvel Cab",
    "description": "Book Pune to Old Panvel Cab with comfortable vehicles and affordable fares."
  },
  {
    "name": "Pune to Panvel Railway Station Cab",
    "description": "Hire Pune to Panvel Railway Station Cab for timely station pickup and drop."
  },
  {
    "name": "Pune to Panvel Metro Cab",
    "description": "Book Pune to Panvel Metro Cab with punctual pickup and professional drivers."
  },
  {
    "name": "Pune to Navi Mumbai Cab",
    "description": "Choose Pune to Navi Mumbai Cab for business travel, airport transfers, and family trips."
  },
  {
    "name": "Pune to Kharghar Cab",
    "description": "Book Pune to Kharghar Cab with affordable pricing and reliable chauffeur service."
  },
  {
    "name": "Pune to Belapur Cab",
    "description": "Hire Pune to Belapur Cab for safe, comfortable, and affordable travel."
  },
  {
    "name": "Pune to Vashi Cab",
    "description": "Book Pune to Vashi Cab with experienced drivers and AC vehicles."
  },
  {
    "name": "Hinjewadi to Panvel Cab",
    "description": "Choose Hinjewadi to Panvel Cab for business travel and airport transfers."
  },
  {
    "name": "Wakad to Panvel Cab",
    "description": "Book Wakad to Panvel Cab with doorstep pickup and transparent fares."
  },
  {
    "name": "Baner to Panvel Cab",
    "description": "Hire Baner to Panvel Cab for comfortable intercity travel."
  },
  {
    "name": "Kharadi to Panvel Cab",
    "description": "Book Kharadi to Panvel Cab for business trips and family travel."
  },
  {
    "name": "Hadapsar to Panvel Cab",
    "description": "Choose Hadapsar to Panvel Cab with fixed fares and experienced drivers."
  },
  {
    "name": "Pimpri Chinchwad to Panvel Cab",
    "description": "Book Pimpri Chinchwad to Panvel Cab for one-way and round-trip travel."
  },
  {
    "name": "Viman Nagar to Panvel Cab",
    "description": "Hire Viman Nagar to Panvel Cab for airport transfers and business travel."
  },
  {
    "name": "Kothrud to Panvel Cab",
    "description": "Book Kothrud to Panvel Cab with comfortable AC vehicles and professional chauffeurs."
  },
  {
    "name": "Aundh to Panvel Cab",
    "description": "Choose Aundh to Panvel Cab for safe and affordable outstation travel."
  },
  {
    "name": "Shivajinagar to Panvel Cab",
    "description": "Book Shivajinagar to Panvel Cab with reliable drivers and transparent pricing."
  }
],

"tableData": [
  ["Pune to Panvel Cab Fare", "Pune to Panvel Cab One Way"],
  ["Pune to Panvel Cab Price", "Pune to Panvel Distance Taxi"],
  ["Pune to Panvel Taxi Fare", "Pune to Panvel Taxi"],
  ["Pune to Panvel Cabs", "Pune to Panvel Cab"],
  ["Pune to Panvel Cab Service", "Pune to Panvel Taxi Service"],
  ["Pune to Panvel Cab Booking", "Online Pune to Panvel Cab Booking"],
  ["Book Pune to Panvel Cab", "Pune to Panvel One Way Cab"],
  ["Pune to Panvel Round Trip Cab", "Pune to Panvel Outstation Cab"],
  ["Pune to Panvel Car Rental", "Pune to Panvel Private Cab"],
  ["Pune to Panvel AC Cab", "Pune to Panvel Intercity Cab"],
  ["Pune to Panvel Travel Cab", "Pune to Panvel Drop Taxi"],
  ["Pune to Panvel Cab Hire", "Pune to Panvel Taxi Booking"],
  ["Innova Crysta Pune to Panvel Cab", "Ertiga Pune to Panvel Cab"],
  ["Sedan Pune to Panvel Cab", "Kia Carens Pune to Panvel Cab"],
  ["Swift Dzire Pune to Panvel Cab", "Hyundai Aura Pune to Panvel Cab"],
  ["Premium Cab Pune to Panvel", "Luxury Cab Pune to Panvel"],
  ["Family Cab Pune to Panvel", "Pune to Panvel Station Cab"],
  ["Pune to New Panvel Cab", "Pune to Old Panvel Cab"],
  ["Pune to Panvel Railway Station Cab", "Pune to Panvel Metro Cab"],
  ["Pune to Navi Mumbai Cab", "Pune to Kharghar Cab"],
  ["Pune to Belapur Cab", "Pune to Vashi Cab"],
  ["Hinjewadi to Panvel Cab", "Wakad to Panvel Cab"],
  ["Baner to Panvel Cab", "Kharadi to Panvel Cab"],
  ["Hadapsar to Panvel Cab", "Pimpri Chinchwad to Panvel Cab"],
  ["Viman Nagar to Panvel Cab", "Kothrud to Panvel Cab"],
  ["Aundh to Panvel Cab", "Shivajinagar to Panvel Cab"]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Pune to Panvel Cab Service",
    WhyChoosedescription: "Trustline Cab offers dependable Pune to Panvel cab services with comfortable vehicles for business travel, family trips, airport transfers, and outstation journeys."
  },
  {
    WhyChooseheading: "Doorstep Pickup Anywhere in Pune",
    WhyChoosedescription: "Get convenient pickup from your home, office, hotel, Pune Airport, Pune Railway Station, or any major location across Pune."
  },
  {
    WhyChooseheading: "Safe Travel with Experienced Drivers",
    WhyChoosedescription: "Our professional chauffeurs are well-acquainted with the Pune-Mumbai Expressway, ensuring a safe, smooth, and timely journey to Panvel."
  },
  {
    WhyChooseheading: "Affordable Cab Fares",
    WhyChoosedescription: "Enjoy budget-friendly pricing with transparent fare details and no hidden charges for your Pune to Panvel cab booking."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers based on your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "One Way & Round Trip Flexibility",
    WhyChoosedescription: "Book one-way cabs, return journeys, or customized travel packages according to your travel plans."
  },
  {
    WhyChooseheading: "Perfect for Airport & Business Travel",
    WhyChoosedescription: "Our Pune to Panvel cabs are ideal for Navi Mumbai Airport transfers, corporate meetings, hotel transfers, and family travel."
  },
  {
    WhyChooseheading: "Instant Booking & 24/7 Support",
    WhyChoosedescription: "Receive quick fare quotations, immediate booking confirmation, and dedicated customer assistance anytime you need a cab."
  }
]

};

const faqData = [
  {
    question: "Does Trustline Cab provide Pune to Panvel cab service?",
    answer: "Yes, Trustline Cab offers reliable Pune to Panvel cab services for one-way trips, round trips, airport transfers, and corporate travel."
  },
  {
    question: "Can I book a one-way cab from Pune to Panvel?",
    answer: "Yes, we provide affordable one-way cab services with flexible pickup timings from any location in Pune."
  },
  {
    question: "Which vehicles are available for Pune to Panvel travel?",
    answer: "Our fleet includes Sedan cars, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for every travel requirement."
  },
  {
    question: "Do you provide pickup from Pune Airport and Railway Station?",
    answer: "Yes, we offer pickup from Pune Airport, Pune Railway Station, hotels, offices, and residential areas across Pune."
  },
  {
    question: "Can I book a round-trip cab to Panvel?",
    answer: "Yes, Trustline Travels offers customized round-trip cab packages according to your travel schedule."
  },
  {
    question: "Are toll and parking charges included in the fare?",
    answer: "Toll charges, parking fees, and applicable taxes are generally charged separately unless specifically included in your booking quotation."
  },
  {
    question: "Is Pune to Panvel cab service available 24/7?",
    answer: "Yes, our cab services are available round the clock for early morning, daytime, and late-night travel."
  },
  {
    question: "Can I reserve my cab in advance?",
    answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup timing."
  },
  {
    question: "Do you provide cabs for corporate and family travel?",
    answer: "Yes, our Pune to Panvel cab services are ideal for business executives, families, tourists, and group travelers."
  },
  {
    question: "How can I book a Pune to Panvel cab with Trustline Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Aditya Kulkarni",
    feedback: "Trustline Travels provided an excellent Pune to Panvel cab service. The driver arrived on time, the vehicle was clean, and the entire journey was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Ritu Sharma",
    feedback: "We booked a cab from Pune to Panvel for a family trip, and the experience was outstanding. The booking process was quick, the fare was transparent, and the ride was safe and relaxing.",
    rating: 5
  }
];






  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Panvel Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-panvel-cab.webp",
  "description": "Book Pune to Panvel cab service with Trustline Travels for safe, comfortable, and affordable intercity travel. Get one-way, round-trip, and outstation taxi services with Sedan, Ertiga, SUV, Innova, Innova Crysta, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6387"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-panvel-cab"
  }
};








  return (
    <div>
<Helmet>
  <title>Pune to Panvel Cab | One Way Taxi Service | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Panvel cab service with Trustline Travels for affordable one-way, round-trip, and outstation travel. Get Sedan, Ertiga, SUV, Innova, and Innova Crysta taxis with professional drivers available 24x7."
  />

  <meta
    name="keywords"
    content="Pune to panvel cab fare, Pune to panvel cab one way, Pune to panvel cab price, Pune to panvel distance taxi, Pune to panvel taxi fare, Pune to panvel taxi, Pune to Panvel Cabs, Pune Panvel cab service, Pune to Panvel one way cab, Pune to Panvel airport taxi, Pune to Panvel Innova cab, Pune Panvel outstation taxi, Pune to Panvel online cab booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/69.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetopanvelcabs;